import { Ref, ComputedRef, isRef } from "vue";
import { computed } from "vue";

/**
 * @function usePrioritizeValues - returns the first defined value
 * don't use on booleans, the returned value wont have a correct meaning or use
 * use usePrioritizeFlags instead
 * @param {ValueType} defaultValue - the default value in case nothing is defined
 * @param {(Ref<ValueType | undefined> | undefined | ValueType)[]}values - the values in order of priority
 * @returns {ComputedRef<ValueType>} - the prioritized value
 */
export default function usePrioritizeValues<ValueType>(
  defaultValue: ValueType,
  ...values: (Ref<ValueType | undefined> | undefined | ValueType)[]
): ComputedRef<ValueType> {
  const value = computed(() => {
    //initialize with the default value
    let theValue = defaultValue;
    //check for every value in values
    for (const oneValue of values) {
      if (isRef(oneValue)) {
        //if the value is defined assign it and break the loop
        if (oneValue.value) {
          theValue = oneValue.value;
          break;
        }
      } else {
        if (oneValue != undefined) {
          theValue = oneValue;
          break;
        }
      }
    }
    //return the obtained value
    return theValue;
  });

  return value;
}
